import { Attr, BelongsTo, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import RecruiterUser from "./RecruiterUser";

@Model()
class Speciality extends ApplicationRecord {
  static jsonapiType = "specialities";

  @Attr() description: string;

  @BelongsTo(RecruiterUser) recruiterUser: RecruiterUser;
}

export default Speciality;
